import React, { useState } from "react";
import axios from "axios";
import DataTable from "../interfaccia/DataTableBase";
import apiUrl from "../Apiurl";

function formatDate(value) {
  return value ? String(value).slice(0, 10) : "";
}

function formatImporto(value) {
  return Number(value || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function ModalRicercaTransazioneDomino({ token, tipoMovimento, onSelect, onClose }) {
  const [testo, setTesto] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");

  const cerca = async () => {
    if (testo.trim().length < 2) {
      setErrore("Inserisci almeno 2 caratteri");
      return;
    }
    setLoading(true);
    setErrore("");
    try {
      const response = await axios.get(apiUrl + "/contab/controlli-corrispettivi/transazioni-domino/ricerca", {
        headers: { Authorization: "Bearer " + token },
        params: { q: testo, tipo: tipoMovimento },
      });
      setRows(response.data.data || []);
    } catch (error) {
      setErrore(error.response?.data?.error || error.message || "Errore ricerca Domino");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: "Tipo", selector: (row) => row.tipoMovimento, width: "110px" },
    { name: "Data", selector: (row) => row.dataTransazione, width: "110px", cell: (row) => formatDate(row.dataTransazione) },
    { name: "Importo", selector: (row) => row.importo, width: "115px", right: true, cell: (row) => formatImporto(row.importo) },
    { name: "Rif. marketplace", selector: (row) => row.riferimentoMarketplace, grow: 1 },
    { name: "Rif. PS", selector: (row) => row.riferimentoPrestashop, width: "130px" },
    { name: "Cliente", selector: (row) => row.nomeCliente, grow: 1 },
    {
      name: "", width: "95px",
      cell: (row) => <button className="dim tastoInputOrizzontale br3" type="button" onClick={() => onSelect(row)}>COLLEGA</button>,
    },
  ];

  return (
    <div className="modal" onClick={onClose}>
      <div id="modal-content" className="sfondoBiancoTema pa3 w-90" onClick={(event) => event.stopPropagation()}>
        <div className="flex justify-between items-center mb3">
          <div className="f4 b">Collega {tipoMovimento === "RIMBORSO" ? "rimborso" : "spedizione"} Domino</div>
          <button className="dim tastoInputOrizzontale br3" type="button" onClick={onClose}>CHIUDI</button>
        </div>
        <div className="flex items-center mb3">
          <input className="inputOrizzontale mr2" value={testo} onChange={(event) => setTesto(event.target.value)} placeholder="Rif. Prestashop, marketplace o nome cliente" onKeyDown={(event) => { if (event.key === "Enter") cerca(); }} />
          <button className="dim tastoInputOrizzontale br3" type="button" onClick={cerca} disabled={loading}>{loading ? "CERCO" : "CERCA"}</button>
        </div>
        {errore && <div className="tastoRosso white pa2 mb2">{errore}</div>}
        <DataTable columns={columns} data={rows} progressPending={loading} dense highlightOnHover pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 20, 50]} noDataComponent={<div className="pa3 colScrittaDef-20">Cerca una transazione Domino</div>} />
      </div>
    </div>
  );
}

export default ModalRicercaTransazioneDomino;
